import { useEffect, useRef } from "react";
import { useBreadcrumbs } from "@/presentation/layout/breadcrumbs_context";

/**
 * Hosts the CPOS Hoops game, a self-contained three.js build that ships as static
 * files in `public/cpos-hoops/`. It runs in an iframe rather than being mounted into
 * this tree: the game owns `document.body`, installs its own window-level pointer and
 * key handlers, and positions its HUD with `position: fixed`. Inside an iframe all of
 * that scopes to the frame, so nothing leaks into the console's layout or shortcuts,
 * and navigating away tears the whole render loop down with the frame.
 */
export function HoopsView() {
  useBreadcrumbs([{ label: "Play CPOS Hoops" }]);
  const frame = useRef<HTMLIFrameElement>(null);

  // The game charges a shot on Space, which only reaches it once the frame holds
  // focus. Focusing on mount means the keyboard works without a priming click.
  useEffect(() => {
    frame.current?.focus();
  }, []);

  return (
    <div className="flex h-[calc(100vh-9rem)] min-h-[480px] flex-col gap-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">CPOS Hoops</h1>
        <p className="text-muted-foreground text-sm">
          45 seconds on the clock. Click into the cabinet to start shooting.
        </p>
      </div>
      <iframe
        ref={frame}
        src="/cpos-hoops/index.html"
        title="CPOS Hoops"
        allow="fullscreen"
        className="bg-muted min-h-0 w-full flex-1 rounded-lg border"
      />
    </div>
  );
}
